import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import get from 'lodash/get'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
} from 'reactstrap'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import { FONTS, COLORS } from '../../../constants'
import "../../../static/css/index.css"

class LeaveRequestPreview extends React.Component {
  render() {
    const newLeaveRequest = get(this.props, 'newLeaveRequest')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showPreview') }
        toggle={ get(this.props, 'handleCloseRequest') }
      >
        <ModalHeader
          toggle={ get(this.props, 'handleCloseRequest') }
        >
          <HeadModal>Leave Request</HeadModal>
        </ModalHeader>
        <ModalBody>
          { get(newLeaveRequest, 'leave_type_id.label') &&
            <div>
              <LabelTextPreview>Leave Type</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newLeaveRequest, 'leave_type_id.label') }
                </ColData>
              </Row>
            </div>
          }
          { get(newLeaveRequest, 'start_date') &&
            <div>
              <LabelTextPreview>Leave Date</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { moment(get(newLeaveRequest, 'start_date')).format('DD/MM/YYYY') } - { moment(get(newLeaveRequest, 'end_date')).format('DD/MM/YYYY') }
                </ColData>
              </Row>
            </div>
          }
          { get(newLeaveRequest, 'leave_time') &&
            <div>
              <LabelTextPreview>Leave Time</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newLeaveRequest, 'leave_time') }
                </ColData>
              </Row>
            </div>
          }
          { get(this.props, 'meta.days') &&
            <div>
              <LabelTextPreview>Total Leave Day</LabelTextPreview>
              <DivData>{ get(this.props, 'meta.days') } days</DivData>
            </div>
          }
          { get(newLeaveRequest, 'approver_id.label') &&
            <div>
              <LabelTextPreview>Approver</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newLeaveRequest, 'approver_id.label') }
                </ColData>
              </Row>
            </div>
          }
          { get(this.props, 'attachment_url') &&
            <div>
              <LabelTextPreview>Attachments</LabelTextPreview>
              <TextMB>(Max 5 MB)</TextMB>
              <Row noGutters>
                <ColData>
                  <a href={ get(this.props, 'attachment_url') }>{ get(this.props, 'filename') }</a>
                </ColData>
              </Row>
            </div>
          }
          { get(newLeaveRequest, 'remark', '') !== '' &&
            <div>
              <LabelTextPreview>Remarks</LabelTextPreview>
              <Row>
                <ColData>
                  { get(newLeaveRequest, 'remark') }
                </ColData>
              </Row>
            </div>
          }
        </ModalBody>
        <ModalFooter style={ { borderTop: 'none' } }>
          <div>
            <CustomButton
              style={ {
                backgroundColor: '#FFFFFF',
                border: '1px solid #CCCCCC',
                color: '#000000',
                marginRight: '5px',
              } }
              onClick={ get(this.props, 'handleBack') }
            >
              Back</CustomButton>
            <CustomButton
              color="success"
              onClick={ get(this.props, 'clickConfirmLeave') }
            >Confirm</CustomButton>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

export default LeaveRequestPreview

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  height: 40px;
  width: fit-content;
  padding-top: 0px;
  padding-bottom: 0px;
`
const LabelTextPreview = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  margin-bottom: 0%;
`
const HeadModal = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  margin: 0px;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.TITLE_SIZE};
`
const ColData = styled(Col)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`
const DivData = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`
const TextMB = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  margin: 0px;
  padding-left: 2%;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/form/leave-preview.js